// import 'jquery-migrate';
import 'jquery-match-height';
import {App} from './lib/app';

import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (document.environments.env !== 'DEV' && document.environments.sentry_dsn) {
	const config = {
		release: document.environments.release,
		environment: document.environments.env
	};
	Raven.config(document.environments.sentry_dsn, config).
		addPlugin(RavenVue, Vue).
		install();
}

const app = new App();

// Match Height settings
app.matchHeight.selector = [
	'.block--icon__title',
	'.block--promo__title',
];

// Side container
// app.sideContainer.selector = [
// 	'',
// ];

// Tooltips settings
app.tooltips.selector = '[rel~=tooltip]';
app.tooltips.id = 'tooltip';


app.init();
